import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  min-width: 0;
  height: 100%;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  overflow: hidden;
  position: relative;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 16px;
    cursor: default;

      .header-period {
        font-size: 12px;
        color: ${(props) => props.theme.colors.inactive};
        font-family: ManropeRegular, sans-serif;
      }

    }

  .drivers-rank-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
  }
`;

export default { Wrapper };
